<template>
  <div class="services-page">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container">
        <div class="logo">知予 AI</div>
        <nav class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/profit">盈利模式</router-link>
          <router-link to="/services" class="active">产品服务</router-link>
          <router-link to="/blog">心理科普</router-link>
          <router-link to="/about">关于我们</router-link>
        </nav>
        <div class="navbar-actions">
          <button class="btn-primary" @click="goToHome">立即体验</button>
        </div>
      </div>
    </header>

    <!-- 英雄区 -->
    <section class="services-hero">
      <div class="container">
        <h1 class="hero-title">产品与服务</h1>
        <p class="hero-desc">为不同用户群体提供专业的心理健康服务解决方案</p>
      </div>
    </section>

    <!-- C端个人服务 -->
    <section class="c-service">
      <div class="container">
        <h2 class="section-title">个人服务</h2>
        <p class="section-desc">为个人用户提供便捷、专业的心理健康服务</p>
        <div class="service-content">
          <div class="service-details">
            <div class="service-card">
              <h3 class="service-subtitle">服务内容</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>AI情绪树洞：24小时在线的AI聊天机器人，随时倾听用户的情绪表达</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>心理测评：专业的心理健康测评工具，帮助用户了解自己的心理状态</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>情绪管理：提供情绪调节技巧和方法，帮助用户更好地管理情绪</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>压力缓解：提供压力缓解的方法和技巧，帮助用户应对生活中的压力</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>睡眠改善：提供睡眠改善的方法和技巧，帮助用户提高睡眠质量</span>
                </li>
              </ul>
            </div>
            <div class="service-card">
              <h3 class="service-subtitle">使用场景</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>职场压力大，需要情绪释放的职场人士</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>学业压力大，考试焦虑的学生</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>长期失眠，情绪低落的人群</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>有轻量倾诉需求但对传统心理咨询存在门槛顾虑的用户</span>
                </li>
              </ul>
            </div>
            <div class="service-card">
              <h3 class="service-subtitle">用户价值</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>24小时在线，随时获得心理支持</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>隐私保护，安全可靠</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>专业支持，科学有效</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>低门槛，易于使用</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- B端机构/咨询师服务 -->
    <section class="b-service">
      <div class="container">
        <h2 class="section-title">机构/咨询师服务</h2>
        <p class="section-desc">为心理机构和个人咨询师提供专业的服务支持</p>
        <div class="service-content">
          <div class="service-details">
            <div class="service-card">
              <h3 class="service-subtitle">合作模式</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>入驻合作：心理机构和个人咨询师可以入驻平台，提供专业服务</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>技术合作：平台提供AI技术支持，帮助机构和咨询师提升服务能力</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>品牌合作：平台与机构进行品牌合作，共同推广心理健康服务</span>
                </li>
              </ul>
            </div>
            <div class="service-card">
              <h3 class="service-subtitle">服务内容</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>AI助手：为咨询师提供AI助手，帮助处理日常咨询工作</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>客户管理：提供客户管理系统，帮助机构和咨询师管理客户信息</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>预约系统：提供在线预约系统，方便客户预约咨询服务</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>数据分析：提供数据分析工具，帮助机构和咨询师了解服务效果</span>
                </li>
              </ul>
            </div>
            <div class="service-card">
              <h3 class="service-subtitle">技术支持</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>AI技术支持：提供先进的AI技术，提升服务质量和效率</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>系统集成：提供系统集成服务，与机构现有系统无缝对接</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>技术培训：提供技术培训，帮助机构和咨询师掌握平台使用方法</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>持续更新：不断更新技术和功能，保持服务的先进性</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业EAP服务 -->
    <section class="eap-service">
      <div class="container">
        <h2 class="section-title">企业EAP服务</h2>
        <p class="section-desc">为企业提供员工心理援助计划，提升员工心理健康水平</p>
        <div class="service-content">
          <div class="service-details">
            <div class="service-card">
              <h3 class="service-subtitle">解决方案</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>员工心理健康评估：定期为员工提供心理健康评估，了解员工心理状态</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>心理热线服务：为员工提供24小时心理热线服务，及时解决员工心理问题</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>心理健康培训：为员工提供心理健康培训，提升员工心理调适能力</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>管理者培训：为企业管理者提供心理健康管理培训，提升管理能力</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>危机干预：为企业提供危机干预服务，应对突发心理危机事件</span>
                </li>
              </ul>
            </div>
            <div class="service-card">
              <h3 class="service-subtitle">实施流程</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>需求评估：了解企业需求，制定个性化的EAP服务方案</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>方案设计：根据企业需求，设计具体的EAP服务方案</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>服务实施：按照方案实施EAP服务，为企业员工提供心理支持</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>效果评估：定期评估EAP服务效果，及时调整服务方案</span>
                </li>
              </ul>
            </div>
            <div class="service-card">
              <h3 class="service-subtitle">成功案例</h3>
              <ul class="service-list">
                <li>
                  <i class="el-icon-check"></i>
                  <span>某大型互联网公司：通过EAP服务，员工满意度提升20%，离职率下降15%</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>某金融机构：通过EAP服务，员工心理压力指数下降30%，工作效率提升25%</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>某制造企业：通过EAP服务，员工心理健康水平显著提升，团队凝聚力增强</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info">
            <p class="contact-item">
              <i class="el-icon-phone"></i>
              <span>联系电话：13100987983</span>
            </p>
            <p class="contact-item">
              <i class="el-icon-position"></i>
              <span>微信号：yxxgx9</span>
            </p>
            <p class="contact-item" style="align-items: flex-start;">
              <i class="el-icon-picture-outline"></i>
              <span><img src="https://h5smapp.dayujh.cn/upload/sys/image/69/9151955851f6033c3ac85bbdbea9a2.jpg" alt="微信二维码"
                    style="width: 220px;height: 300px;"></span>
            </p>
          </div>
          <div class="contact-form">
            <el-form :model="form" :rules="rules" ref="contactForm" label-position="top">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的电话"></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="company">
                <el-input v-model="form.company" placeholder="请输入您的公司名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="submit-btn" @click="submitForm" :loading="loading">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'Services',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        company: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        company: [
          { required: false, message: '请输入公司名称', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 构建请求参数
          const formData = {
            name: this.form.name,
            phone: this.form.phone,
            company: this.form.company
          };
          // 发送请求
          fetch('https://aixinli.dayujh.cn/admin/contact/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.$message.success(data.msg);
              // 重置表单
              this.$refs.contactForm.resetFields();
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message.error('网络错误，请稍后重试');
            console.error('Error:', error);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.services-page {
  min-height: 100vh;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #9c89b8;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
}

.nav-links a:hover {
  color: #9c89b8;
}

.nav-links .active {
  color: #9c89b8;
  font-weight: bold;
}

.navbar-actions {
  display: flex;
  gap: 10px;
}

.btn-primary {
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(156, 137, 184, 0.3);
}

/* 英雄区 */
.services-hero {
  padding: 120px 0 80px;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
  text-align: center;
}

.hero-title {
  font-size: 48px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.hero-desc {
  font-size: 24px;
  color: #666;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* 通用区块样式 */
.section-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.section-desc {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* C端个人服务 */
.c-service {
  padding: 80px 0;
  background-color: white;
}

.service-content {
  display: flex;
  gap: 60px;
  align-items: center;
  flex-wrap: wrap;
}

.service-image {
  flex: 1;
  min-width: 300px;
}

.service-image img {
  width: 100%;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.service-details {
  flex: 1;
  min-width: 300px;
}

.service-subtitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.service-list {
  list-style: none;
  margin-bottom: 40px;
}

.service-list li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.service-list li i {
  color: #9c89b8;
  font-size: 20px;
  margin-top: 2px;
}

/* 服务卡片样式 */
.service-card {
  background-color: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.service-card .service-subtitle {
  margin-bottom: 20px;
  color: #333;
}

.service-card .service-list {
  margin-bottom: 0;
}

/* B端机构/咨询师服务 */
.b-service {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
}

/* 企业EAP服务 */
.eap-service {
  padding: 80px 0;
  background-color: white;
}

/* 联系我们 */
.contact-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
}

.contact-content {
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
}

.contact-info {
  flex: 1;
  min-width: 300px;
}

.contact-subtitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
}

.contact-item i {
  color: #9c89b8;
  font-size: 20px;
}

.contact-form {
  flex: 1;
  min-width: 300px;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 页脚 */
.footer {
  background-color: #333;
  color: white;
  padding: 60px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-logo h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #9c89b8;
}

.footer-logo p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.footer-links h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: white;
}

.footer-links ul {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #9c89b8;
}

.footer-contact h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: white;
}

.footer-contact p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.footer-copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer-copyright p {
  margin-bottom: 5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 10px;
  }
  
  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .service-content {
    flex-direction: column;
  }
  
  .contact-content {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
  }
  
  .section-title {
    font-size: 28px;
  }
}
</style>